module.exports = __webpack_public_path__ + "img/coinbase.78b2915b.svg";